import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetTillagePlansInputDto, ImportTillagePlansInputDto, TillagePlanCreateDto, TillagePlanDto, TillagePlanExcelDownloadDto, TillagePlanProgressPercentageBulkUpdateItemDto, TillagePlanUpdateDto } from '../dtos/tillage-plan/models';

@Injectable({
  providedIn: 'root',
})
export class TillagePlanService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: TillagePlanCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto>({
      method: 'POST',
      url: '/api/operational/tillagePlans',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/tillagePlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/tillagePlans',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto>({
      method: 'GET',
      url: `/api/operational/tillagePlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/tillagePlans/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetTillagePlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TillagePlanDto>>({
      method: 'GET',
      url: '/api/operational/tillagePlans',
      params: { periodId: input.periodId, weekNumber: input.weekNumber, weekNumberFrom: input.weekNumberFrom, weekNumberTo: input.weekNumberTo, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, propertyLocationId: input.propertyLocationId, vendorId: input.vendorId, tillageProgressArea: input.tillageProgressArea, tillageProgressAreaFrom: input.tillageProgressAreaFrom, tillageProgressAreaTo: input.tillageProgressAreaTo, tillageProgressPercentage: input.tillageProgressPercentage, tillageProgressPercentageFrom: input.tillageProgressPercentageFrom, tillageProgressPercentageTo: input.tillageProgressPercentageTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: TillagePlanExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/tillagePlans/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, periodId: input.periodId, weekNumber: input.weekNumber, weekNumberFrom: input.weekNumberFrom, weekNumberTo: input.weekNumberTo, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, propertyLocationId: input.propertyLocationId, vendorId: input.vendorId, tillageProgressArea: input.tillageProgressArea, tillageProgressAreaFrom: input.tillageProgressAreaFrom, tillageProgressAreaTo: input.tillageProgressAreaTo, tillageProgressPercentage: input.tillageProgressPercentage, tillageProgressPercentageFrom: input.tillageProgressPercentageFrom, tillageProgressPercentageTo: input.tillageProgressPercentageTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto[]>({
      method: 'GET',
      url: '/api/operational/tillagePlans/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  import = (input: ImportTillagePlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto[]>({
      method: 'POST',
      url: '/api/operational/tillagePlans/import',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: TillagePlanUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto>({
      method: 'PUT',
      url: `/api/operational/tillagePlans/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateProgressPercentage = (input: TillagePlanProgressPercentageBulkUpdateItemDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TillagePlanDto>({
      method: 'PUT',
      url: '/api/operational/tillagePlans/progress-percentage',
      body: input,
    },
    { apiName: this.apiName,...config });
}